const notFound = {
  path: '/:pathMatch(.*)*',
  redirect: { name: 'default' }
}

export default notFound
